import { ConfirmDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

export const ApproveInspection = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.approveInspections(drawId, afterActionExecuted);
  }

  return (
    <ConfirmDialog
      open={drawActionsStore.isApproveInspectionDialogOpen}
      confirmButtonText='Confirm'
      handleClose={() => drawActionsStore.setIsApproveInspectionDialogOpen(false)}
      handleCancel={() => drawActionsStore.setIsApproveInspectionDialogOpen(false)}
      handleConfirm={confirmHandler}
      title={'Inspections Approval'}
      body={`Are you sure you want to approve the inspections?`}
    />
  );
});
